// @ts-ignore
import { elk } from '@tencent/ppd-base-libs';
/**
 * 上报SDK调用日志
 * @param key 调用方法
 * @param data 方法调用时传入参数
 */
function reportLog(key, data) {
    const body = data || {};
    elk({ key, body });
    console.log(key, '===> ', JSON.stringify(body, null, 2));
}
export class WxInvokeReport {
    name;
    isReport = false;
    get isNeedReport() {
        return !!this.name && this.isReport;
    }
    ;
    constructor(name, report) {
        this.name = name;
        this.isReport = !!report;
    }
    /**
       * 调用jsapi前的上报
       * @param data
       */
    invokeBefore(data) {
        if (this.isNeedReport) {
            reportLog(`jsapi_before_call_${this.name}`, data);
        }
    }
    /**
       * jsapi回调后的上报
       * @param data
       */
    invokeAfter(data) {
        if (this.isNeedReport) {
            reportLog(`jsapi_call_${this.name}`, data);
        }
    }
}
//# sourceMappingURL=report.js.map